import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const MeetingsTraChallengeInfo = withConfig(theme => styled('div', { label: 'MeetingsTraChallengeInfo' })`
    display: block;
    flex: 1 1 0%;
    font-size: ${theme.star.fontSize.regular};
    padding: 10px 5px;
    position: relative;
    text-align: center;
`);

interface FiltersWrapperTrapChallengePropsType {
    variant: DefaultComponentVariantType | null;
}

export const FiltersWrapperTrapChallenge = withConfig(theme => styled('div', { label: 'FiltersWrapperTrapChallenge' })<FiltersWrapperTrapChallengePropsType>`
    padding: 8px 0 8px 8px;
    border: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.raceSummary.borderColor}`};
`);
